<template>
  <div>
    <h2 class="text-underline is-size-4 mb-2">
      Réinscrire {{ customersFirstname }}
    </h2>
    <div
      v-for="(stageByCustomer, stageByCustomerIndex) in registrationStages"
      :key="`stage-by-customer-index-${stageByCustomerIndex}`"
    >
      <p
        class="has-text-weight-bold mt-5 mb-1"
        v-if="registrationStages.length > 1"
      >
        Cours disponible pour <u>{{ stageByCustomer.customer.firstname }}</u>
      </p>
      <div class="columns is-multiline">
        <div
          v-for="(plannedStage, index) in stageByCustomer.planned_stages"
          :key="`planned-stage-index-${index}`"
          class="column is-6"
        >
          <stage-registration-card
            :customer="stageByCustomer.customer"
            :stage="plannedStage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StageRegistrationCard from "@/components/partial/stagesPlanner/StageRegistrationCard.vue";

export default {
  name: "StageRegistrationList",
  components: { StageRegistrationCard },
  props: {
    registrationStages: {
      type: Array,
      required: true
    }
  },

  computed: {
    customersFirstname () {
      const customers = [];
      for (const plannedStageByCustomer of this.registrationStages) {
        customers.push(plannedStageByCustomer.customer.firstname)
      }
      return customers.join(", ");
    }
  }
};
</script>
